// Admin wrapper for order list - passes admin flag
import OrderList from "../../order/index";

export default function AdminOrderList() {
  return <OrderList admin />;
}
